import React from "react";
import _ from "i18n";
import { connect } from "react-redux";
import { Icon } from "antd";
import { generateFollowUp } from "../../../../actions/thunks/eventStats";

const GenerateFollowUp = ({
  budgetManagement,
  budgetPerMonth,
  globalBudget,
  generateFollowUp
}) => {

  const handleGenerateFollowUp = () => {
    const { appType, year, budgetPerMonth, globalBudget: { totalHTVA, registrantsCount, pricePerUnit } } = budgetManagement;
    generateFollowUp(appType, year, budgetPerMonth, totalHTVA, registrantsCount, pricePerUnit);
  };

  const { year } = budgetManagement;
  const registrantsCounts = budgetPerMonth.map((item) => item.registrantsCount);

  return (
    <div className={'create-BM-main-content-generate-follow-up'}>
      <fieldset className={'generate-follow-up-fieldset'}>
        <legend className={'my-legend'}>{_('FOLLOW_UP')}</legend>
        <div className={'follow-up-icon'}>
          <img src="/img/icons/manage-BM/follow-up.svg" />
        </div>
        <div className={'follow-up-title'}>{_('NO_ANALYSIS')}</div>
        <div className={'follow-up-text'}>
          <p className={'mb-2'}>
            {_('FOLLOW_UP_TXT1').replace('{year}', year)}
          </p>
          <p>{_('FOLLOW_UP_TXT2').replace('{year}', year)}</p>
        </div>
        <button className={'follow-up-button'} disabled={globalBudget.pricePerUnit === '' || globalBudget.registrantsCount === '' || registrantsCounts.includes('') || budgetManagement.generateFollowUp.processing} onClick={generateFollowUp} >
          <span>{_('GENERATE_FOLLOW_UP')}</span>
          {budgetManagement.generateFollowUp.processing === true && <Icon className="ml-2" type="sync" spin />}
        </button>
      </fieldset>
    </div>
  );
};

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
  budgetPerMonth: state.budgetManagement.budgetPerMonth,
  globalBudget: state.budgetManagement.globalBudget,
});

const mapDispatchToProps = {
  generateFollowUp
};

export default connect(mapStateToProps, mapDispatchToProps)(GenerateFollowUp);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/GenerateFollowUp.js